import { useEffect } from 'react';
import Logo from "../../elements/logo/Logo";
import NavTwo from './NavTwo';
import { FiX } from "react-icons/fi";

const MobileMenu = ({show, onClose}) => {
    useEffect(() => {
        if (!show) return;

        const elements = document.querySelectorAll('.popup-mobile-menu .has-droupdown > a');
        const elementsTwo = document.querySelectorAll('.popup-mobile-menu .with-megamenu > a');

        const cleanupFns = [];

        elements.forEach((el) => {
            const handler = function () {
                this.parentElement.querySelector('.submenu').classList.toggle("active");
                this.classList.toggle("open");
            };
            el.addEventListener("click", handler);
            cleanupFns.push(() => el.removeEventListener("click", handler));
        });

        elementsTwo.forEach((el) => {
            const handler = function () {
                this.parentElement.querySelector('.rn-megamenu').classList.toggle("active");
                this.classList.toggle("open");
            };
            el.addEventListener("click", handler);
            cleanupFns.push(() => el.removeEventListener("click", handler));
        });

        return () => {
            cleanupFns.forEach((fn) => fn());
        };
    }, [show]);

    return (
        <div className={`popup-mobile-menu ${show ? "active": ""}`}>
            <div className="inner">
                <div className="header-top">
                    <Logo 
                        image={`${process.env.PUBLIC_URL}/images/logo/logo.png`}
                        image2={`${process.env.PUBLIC_URL}/images/logo/logo-dark.png`}
                    />
                    <div className="close-menu">
                        <button className="close-button" onClick={onClose}><FiX /></button>
                    </div>
                </div>
                <NavTwo onItemClick={onClose} />
            </div>
        </div>
    )
}
export default MobileMenu;